import { lazy } from "react";
import { Route } from "react-router-dom";
import Login from "@/pages/Login";
import Index from "@/pages/Index";
import RouteGuard from "@/components/RouteGuard";

const Router = lazy(() => import("@/pages/Router"));
const EsqueciSenha = lazy(() => import("@/pages/EsqueciSenha"));
const RedefinirSenha = lazy(() => import("@/pages/RedefinirSenha"));
const AlterarSenha = lazy(() => import("@/pages/AlterarSenha"));
const PoliticaPrivacidade = lazy(() => import("@/pages/PoliticaPrivacidade"));
const TermosUso = lazy(() => import("@/pages/TermosUso"));
const ManualUsuario = lazy(() => import("@/pages/ManualUsuario"));
const Unsubscribe = lazy(() => import("@/pages/Unsubscribe"));
const Configurar2FA = lazy(() => import("@/pages/Configurar2FA"));
const Verificar2FA = lazy(() => import("@/pages/Verificar2FA"));
const RecuperarComBackupCode = lazy(() => import("@/pages/RecuperarComBackupCode"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const OAuthConsent = lazy(() => import("@/pages/OAuthConsent"));

const allRoles = ["developer", "super_admin", "admin", "professor", "aluno"] as const;
const AuthGuard = ({ children }: { children: React.ReactNode }) => (
  <RouteGuard allowedRoles={[...allRoles]}>{children}</RouteGuard>
);

export const publicRoutes = (
  <>
    <Route path="/" element={<Index />} />
    <Route path="/login" element={<Login />} />
    <Route path="/esqueci-senha" element={<EsqueciSenha />} />
    <Route path="/redefinir-senha" element={<RedefinirSenha />} />
    <Route path="/alterar-senha" element={<AuthGuard><AlterarSenha /></AuthGuard>} />
    <Route path="/router" element={<Router />} />
    <Route path="/configurar-2fa" element={<Configurar2FA />} />
    <Route path="/verificar-2fa" element={<Verificar2FA />} />
    <Route path="/recuperar-2fa" element={<RecuperarComBackupCode />} />
    <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
    <Route path="/termos-de-uso" element={<TermosUso />} />
    <Route path="/manual" element={<ManualUsuario />} />
    <Route path="/unsubscribe" element={<Unsubscribe />} />
    <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
    <Route path="*" element={<NotFound />} />
  </>
);
